<app-header></app-header>

<ng-container *ngIf="!isError; else HTTPError">
  <ng-container *ngIf="showLoading; else content">
    <app-loading-sti> </app-loading-sti>
  </ng-container>
  
  <ng-template #content>
    <ion-content scrollbar>
      <div *ngIf="!p.renderMobile" class="margin-bottom-8">
        <app-breadcrumb></app-breadcrumb>
      </div>
      <ion-grid class="no-padding-grid-box">
        <ion-row class="no-padding">
          <ion-col size="12" class="no-padding">
            <div class="under-header">
              <ion-label class="under-header__order-number">
                <h1 *ngIf="!p.renderMobile">
                  {{'MARKET.ORDER_NR' | translate}}{{orderServ.order.id}}
                </h1>
              </ion-label>
              <div class="under-header__container">
                <div
                  class="under-header__date-container"
                  [ngClass]="p.renderMobile ? 'order-2': 'order-1'"
                >
                  <ion-label class="under-header__date-header">
                    {{'MARKET.DATE_OF_PLACING' | translate}}
                  </ion-label>
                  <ion-label class="under-header__date">
                    {{orderServ.order.dateCreated | dateSti}}
                  </ion-label>
                </div>
                <div
                  *ngIf="canChangeStatus; else userStutusView"
                  class="under-header__form"
                  [ngClass]="p.renderMobile ? 'order-1': 'order-2'"
                >
                  <form [formGroup]="form">
                    <app-select-dropdown
                      [data]="statusNames"
                      [value]="currentStatus"
                      formControlName="status"
                      (changeValueEvent)="onValueChanged($event)"
                    >
                    </app-select-dropdown>
                  </form>
                </div>
                <ng-template #userStutusView>
                  <div class="under-header__user-status-view">
                    <app-status
                      [directionColumn]="false"
                      [color]="
                      dictionaryServ.getDictionaryValueColor(
                        dictionaryServ.reportTaskStatusValues,
                          currentStatus.id
                        )
                      "
                      [name]="currentStatus.name"
                    ></app-status>
                  </div>
                </ng-template>
              </div>
            </div>
          </ion-col>
        </ion-row>
        <ion-row justify-content-center class="display-flex">
          <ion-col
            [ngClass]="p.renderMobile ? 'order-2': 'order-1'"
            size="12"
            size-xl="9"
          >
            <ion-grid class="no-padding">
              <ion-row class="small-padding" justify-content-center>
                <ion-col class="full-width">
                  <div class="main-column-content">
                    <div class="ion-text">
                      <h2>{{ 'MARKET.PRODUCTS' | translate}}</h2>
                    </div>
                    <app-pagination-client-side
                      [componentRef]="componentRef"
                      [options]="options"
                      [columns]="columnsDefinition"
                      (rowsLoaderReady)="rowsLoaderServiceReady($event)"
                      (refreshRequest)="rowsLoaderInit()"
                    >
                    </app-pagination-client-side>
                    <div
                      *ngIf="orderServ.order.description"
                      class="ion-text description-title"
                    >
                      <h2>{{ 'MARKET.ORDER_DESCRIPTION' | translate}}</h2>
                      {{orderServ.order.description}}
                    </div>
                  </div>
                  <ion-grid class="main-column-content">
                    <ion-row class="card-row ion-align-items-stretch">
                      <ion-col
                        size="12"
                        size-xl="5"
                        class="card-row__client-provider-column"
                      >
                        <div class="ion-text w-100">
                          <h2 class="card-row__header">
                            {{ 'MARKET.PROVIDER' | translate}}
                          </h2>
                        </div>
                        <ion-card class="color-card">
                          <ion-item lines="none">
                            <ion-avatar
                              *ngIf="companyProvider && companyProvider.logo"
                              slot="start"
                            >
                              <ion-img
                                [src]="companyProvider.logo.filePath"
                              ></ion-img>
                            </ion-avatar>
                            <ion-card-header
                              class="card-row__provider-info-header"
                            >
                              <ion-card-title
                                >{{orderServ.order.companyProvider.name}}</ion-card-title
                              >
                            </ion-card-header>
                          </ion-item>

                          <ion-card-content>
                            {{companyProvider?.description}}
                          </ion-card-content>

                          <ion-card-content
                            class="card-row__icon-and-text"
                            *ngIf="companyProvider?.telephone"
                          >
                            <ion-icon name="call-outline"></ion-icon>
                            {{companyProvider?.telephone}}
                          </ion-card-content>
                        </ion-card>
                      </ion-col>
                      <ion-col
                        *ngIf="!p.renderMobile"
                        size="12"
                        size-xl="2"
                        class="card-row__icon-column"
                      >
                        <div class="card-row__over-icon-container"></div>
                        <div class="card-row__icon-container">
                          <ion-icon name="chevron-forward-outline"></ion-icon>
                        </div>
                      </ion-col>
                      <ion-col size="12" size-xl="5">
                        <div class="ion-text">
                          <h2 class="card-row__header">
                            {{ 'MARKET.CUSTOMER' | translate}}
                          </h2>
                        </div>
                        <ion-card *ngIf="userServ.user" class="color-card">
                          <ion-item lines="none">
                            <ion-avatar
                              *ngIf="companyProvider && companyProvider.logo"
                              slot="start"
                            >
                              <app-avatar [user]="userServ.user" [big]="true"></app-avatar>
                            </ion-avatar>
                            <ion-card-header class="provider-info-header">
                              <ion-card-title
                                >{{userServ.user.firstName}}
                                {{userServ.user.lastName}}</ion-card-title
                              >
                            </ion-card-header>
                          </ion-item>

                          <ion-card-content *ngIf="userServ.user.company">
                            {{userServ.user.company.name}}
                          </ion-card-content>

                          <ion-card-content class="card-row__icon-and-text">
                            <ion-icon item-start name="mail-outline"></ion-icon>
                            <ion-label> {{userServ.user.email}} </ion-label>
                          </ion-card-content>

                          <ion-card-content
                            class="card-row__icon-and-text"
                            *ngIf="userServ.user.mobilePhone"
                          >
                            <ion-icon name="call-outline"></ion-icon>
                            <ion-label>
                              {{userServ.user.mobilePhone}}
                            </ion-label>
                          </ion-card-content>
                        </ion-card>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-col>
          <ion-col
            [ngClass]="p.renderMobile ? 'order-1': 'order-2'"
            size="12"
            size-xl="3"
          >
            <ion-grid class="box">
              <ion-row class="small-padding" justify-content-center>
                <ion-col class="full-width">
                  <div>
                    <ion-label>
                      <h1>{{'MARKET.ORDER_VALUE' | translate}}</h1>
                    </ion-label>
                    <div class="cost-container">
                      <ion-label>
                        {{ 'MARKET.TOTAL_COST' | translate}}
                      </ion-label>
                      <ion-label class="cost-container__cost">
                        {{orderServ.order.orderCost | currency: ' '}} {{'PLN'|
                        translate}}
                      </ion-label>
                    </div>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ng-template>
</ng-container>

<ng-template #HTTPError>
  <ion-content>
    <app-api-not-found
      name="MARKET.ORDER"
      link="app/market"
      returnText="MARKET.RETURN_TO_ORDER_LIST"
      [status]="errorStatus"
    >
    </app-api-not-found>
  </ion-content>
</ng-template>
